import LicenseDataGrid from './LicenseDataGrid.jsx';
import LicensingCreation from './licensing.jsx';
import React from 'react';
import Page from '../../components/Page';
import {
    Tabs,
    Tab,
} from '@mui/material';

import "./licensing.css";
import TabPanel from '../../components/TabPanel';

function LicensingPage (){
    /// licensing Page

    const [value, setValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <Page title="Licensing">
            <div style={{width: "100%"}}>
            <Tabs value={value} onChange={handleTabChange} style={{ borderBottom: '2px solid darkGray', paddingBottom: '10px' }}>
                    <Tab label="License Table" />
                    <Tab label="License Generator" />
            </Tabs>
            <TabPanel className="licensingTab" value={value} index={0} style={{textAlign:'left'}}>
                <LicenseDataGrid/>
            </TabPanel>
            <TabPanel className="licensingTab" value={value} index={1} style={{textAlign:'left'}}>
                <LicensingCreation/>
            </TabPanel>
            </div>
        </Page>
    )
}

export default LicensingPage;